import { React, useState, useEffect, useContext, useMemo } from "react";
import { Formik, Form, Field } from "formik";
import DropdownSelect from "../DropdownSelect";
import Buttons from "../Buttons";
import ErrorMessage from "../ErrorMessage";
import * as Yup from "yup";
import MyInputField from "../MyInputField";
import { MyContext } from "../MyContext";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { CSSTransition } from "react-transition-group";
import { useRef } from "react";

import loader from "./circle.svg";

dayjs.extend(customParseFormat);

const meet_type = [
  { id: "LOCAL", name: "Vor-Ort Termin" },
  // { id: "ONLINE_VIDEO", name: "Online Videomeeting" },
];

const salutation = [
  { id: 1, name: "keine Angabe" },
  { id: 2, name: "Frau" },
  { id: 3, name: "Herr" },
];

const duration = 300;

// 2: Umzug, 5: Tarifberatung, 7: Forderungsmanagement, 1: Allgemeine Beratung,
// 11: Energiedienstleistungen, 10: SmartMeter, 9: Hausanschluss, 12: Sonstige netzbezogene Themen
const concernOrder = [2, 5, 7, 1, 11, 10, 9, 12];

const sortConcerns = (concerns) =>
  [...concerns].sort((a, b) => {
    const indexA = concernOrder.indexOf(a.id);
    const indexB = concernOrder.indexOf(b.id);
    return (
      (indexA === -1 ? concernOrder.length : indexA) -
      (indexB === -1 ? concernOrder.length : indexB)
    );
  });

const Formular = () => {
  const [locations, setLocations] = useState([]);
  const [concerns, setConcerns] = useState([]);
  const [date, setDate] = useState(null);
  const [dates, setDates] = useState({});
  const [error, setError] = useState(false);
  const [loadingDates, setLoadingDates] = useState(false);
  const {
    userData,
    setUserData,
    setSubmitStatus,
    isError,
    isSuccess,
    isLoading,
    isIdle,
  } = useContext(MyContext);

  const [status, setStatus] = useState("idle");

  const DisplayingErrorMessagesSchema = useMemo(
    () =>
      Yup.object({
        firstname: Yup.string().required("Vorname ist ein Pflichtfeld"),
        lastname: Yup.string().required("Nachnname ist ein Pflichtfeld"),
        meet_type: Yup.string().required(
          "Bitte wählen Sie die Art des Termins aus!"
        ),
        location: Yup.string().required(
          "Bitte wählen Sie ein Service-Center aus!"
        ),
        concern: Yup.string().required("Bitte wählen Sie ein Anliegen aus!"),
        issue: Yup.string().test(
          "required-for-allgemeine-beratung",
          "Bei einer Allgemeinen Beratung müssen Sie Ihr Anliegen beschreiben.",
          function (value) {
            const selectedConcern = concerns.find(
              (c) => String(c.id) === String(this.parent.concern)
            );
            if (selectedConcern?.name === "Allgemeine Beratung") {
              return !!value && value.trim().length > 0;
            }
            return true;
          }
        ),
        date: Yup.string().required("Bitte wählen Sie ein Datum aus!"),
        time: Yup.string().required("Bitte wählen Sie eine Uhrzeit aus!"),
        checked: Yup.bool().oneOf(
          [true],
          "Bitte stimmen Sie der Nutzung ihrer Email Adresse zu!"
        ),
        email: Yup.string()
          .email("Ungültige Email")
          .required("Bitte geben Sie eine Email Adresse an!"),
        number: Yup.string().required("Bitte geben Sie eine Telefonnummer an!"),
      }),
    [concerns]
  );

  const cssTansition1 = useRef(null);
  const cssTansition2 = useRef(null);

  useEffect(() => {
    if (isSuccess) {
      window.scrollTo(0, 0);
    }
  }, [isSuccess]);

  useEffect(() => {
    setStatus("loading");
    Promise.all([loadConcerns(), loadLocations()]).then(
      () => setStatus("success"),
      () => setStatus("error")
    );
  }, []);

  const loadLocations = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/locations/`
      );
      if (!response.ok) {
        throw Error(response.statusText);
      } else {
        const data = await response.json();
        setLocations(data.filter(location => location.id === 2))
      }
    } catch (error) {
      setError(true);
    }
  };

  const loadConcerns = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/concerns/`
      );
      if (!response.ok) {
        throw Error(response.statusText);
      } else {
        const data = await response.json();
        setConcerns(data);
      }
    } catch (error) {
      setError(true);
    }
  };

  const loadDate = async (concern_id, location_id) => {
    if (concern_id && location_id) {
      setLoadingDates(true);
      try {
        const response = await fetch(
          `${
            process.env.REACT_APP_API_URL
          }/appointments/free/?concern=${concern_id}&location=${location_id}&date_end=${dayjs()
            .add(2, "week")
            .format("YYYY-MM-DD")}`
        );
        if (!response.ok) {
          throw Error(response.statusText);
        } else {
          const data = await response.json();

          // Umwandeln in Objekt mit key = datum und value = array von Zeiten
          let d = {};
          data.forEach((item) => {
            const [start_date, start_time] = item.start.split(" ");
            d[dayjs(start_date).format("DD.MM.YYYY")] = [
              ...(d[dayjs(start_date).format("DD.MM.YYYY")] ?? []),
              dayjs(start_time, "HH:mm:ss").format("HH:mm"),
            ];
          });
          setDates(d);
          setLoadingDates(false);
        }
      } catch (error) {
        setError(true);
        setLoadingDates(false);
      }
    }
  };

  // return (
  //   <div className="containerAussen">
  //     <header className="header">
  //       <img
  //         src={`${process.env.PUBLIC_URL ?? ""}/SW_witten.svg`}
  //         alt="logo"
  //       ></img>
  //     </header>
  //     <main>
  //       <div className="container" style={{ minHeight: "80vh" }}>
  //         <div className="containerForm">
  //           <h1 className="formularHead">Termin vereinbaren</h1>
  //           <h2>
  //             Aufgrund von Wartungsarbeiten sind im Moment leider keine
  //             Terminbuchungen möglich.
  //           </h2>
  //           <h2> Wir sind in Kürze wieder für Sie da.</h2>
  //         </div>
  //       </div>
  //     </main>
  //     <footer className="footer">
  //       <ul className="footer__list">
  //         <li className="footer__list-item">
  //           <a
  //             className="footer__link"
  //             href="https://www.stadtwerke-witten.de/impressum"
  //             target="_blank"
  //             rel="noreferrer"
  //           >
  //             Impressum
  //           </a>
  //         </li>
  //         <li className="footer__list-item">
  //           <a
  //             className="footer__link"
  //             href="https://www.stadtwerke-witten.de/datenschutz"
  //             target="_blank"
  //             rel="noreferrer"
  //           >
  //             Datenschutz
  //           </a>
  //         </li>
  //       </ul>
  //     </footer>
  //   </div>
  // );

  return (
    <div className="containerAussen">
      <header className="header">
        <img
          src={`${process.env.PUBLIC_URL ?? ""}/SW_witten.svg`}
          alt="logo"
        ></img>
      </header>
      {error && (
        <ErrorMessage message={"Ein Fehler ist aufgetreten!"}></ErrorMessage>
      )}
      {isLoading || isIdle || isError ? (
        <div className="container">
          <div className="containerForm">
            <h1 className="formularHead">Termin vereinbaren</h1>
            <Formik
              initialValues={{
                salutation: 1,
                firstname: "",
                lastname: "",
                street: "",
                place: "",
                plz: "",
                email: "",
                number: "",
                issue: "",
                meet_type: "",
                location: locations.length === 1 ? locations[0].id : "",
                concern: "",
                date: "",
                time: "",
                reachability: "",
                checked: false,
              }}
              enableReinitialize
              validationSchema={DisplayingErrorMessagesSchema}
              onSubmit={async (values) => {
                setSubmitStatus("loading");
                const timeanddate =
                  dayjs(values.date, "DD.MM.YYYY").format("YYYY-MM-DD") +
                  "T" +
                  values.time;
                const response = await fetch(
                  `${process.env.REACT_APP_API_URL}/appointments/`,
                  {
                    headers: {
                      accept: "application/json",
                      "content-type": "application/json",
                    },
                    method: "post",
                    body: JSON.stringify({
                      customer: {
                        salutation: values.salutation,
                        first_name: values.firstname,
                        last_name: values.lastname,
                        street: values.street,
                        place: values.place,
                        zip_code: values.plz,
                        phone_number: values.number,
                        email: values.email,
                        reachability: values.reachability,
                      },
                      meet_type: values.meet_type,
                      location: values.location,
                      start: timeanddate,
                      concern: values.concern,
                      concern_custom_text: values.issue,
                    }),
                  }
                );

                const data = await response.json();
                if (!response.ok) {
                  setSubmitStatus("error");
                  const error = (data && data.message) || response.status;
                } else {
                  setUserData(() => data);
                  setSubmitStatus("success");
                }
              }}
            >
              {({ errors, touched, values, setFieldTouched }) => {
                const selectedConcern = concerns.find(
                  (c) => String(c.id) === String(values.concern)
                );
                const isAllgemeineBeratung =
                  selectedConcern?.name === "Allgemeine Beratung";
                return (
                <Form className="form">
                  <h2 className="form-headline" style={{ marginTop: 0 }}>
                    Wie können wir Ihnen helfen? (1 / 3)
                  </h2>
                  {locations.length > 1 ? (
                    <DropdownSelect
                      items={locations}
                      name="location"
                      label="das Servicecenter"
                      onSelectedItemChange={(selectedItem) => {
                        loadDate(selectedItem, values.concern);
                      }}
                      required
                    />
                  ) : null}
                  <DropdownSelect
                    items={sortConcerns(concerns)}
                    name="concern"
                    label="Ihr Anliegen"
                    onSelectedItemChange={(selectedItem) => {
                      loadDate(selectedItem, values.location);
                    }}
                    disabled={concerns.length <= 0}
                    required
                  />

                  <DropdownSelect
                    name="meet_type"
                    items={meet_type}
                    label="die Art des Termins:"
                    required
                  />
                  <CSSTransition
                    nodeRef={cssTansition1}
                    in={
                      !(
                        values.location === "" ||
                        values.concern === "" ||
                        values.meet_type === ""
                      )
                    }
                    classNames="fade"
                    timeout={duration}
                  >
                    <div className="fade-container" ref={cssTansition1}>
                      <h2 className="form-headline">
                        Wählen Sie Ihren Wunschtermin (2/3)
                      </h2>
                      {!loadingDates ? (
                        <>
                          <DropdownSelect
                            items={Object.keys(dates).map((d) => ({
                              id: d,
                              name: d,
                            }))}
                            name="date"
                            label="ein Datum"
                            key="index"
                            onSelectedItemChange={(selectedItem) => {
                              setDate(selectedItem);
                            }}
                            required
                            disabled={!Boolean(values.concern)}
                          />
                          <DropdownSelect
                            items={
                              date
                                ? dates[date]
                                    .map((d) => ({ id: d, name: d }))
                                    .reduce((acc, cur) => {
                                      const index = acc.findIndex((item) => {
                                        return item.id === cur.id;
                                      });
                                      if (index === -1) {
                                        return [...acc, cur];
                                      }
                                      return acc;
                                    }, [])
                                : []
                            }
                            name="time"
                            label="eine Uhrzeit"
                            disabled={!Boolean(values.date)}
                            required
                          />
                        </>
                      ) : (
                        <p className="loader">
                          <img src={loader} alt="" />
                          Lade freie Termine...
                        </p>
                      )}
                      <label htmlFor="issue">
                        Was können wir für Sie tun?
                        {isAllgemeineBeratung && <sup>*</sup>}
                      </label>
                      <Field
                        as="textarea"
                        name="issue"
                        placeholder="Ihr Anliegen"
                        className={
                          touched.issue && errors.issue
                            ? "textareaerror"
                            : "textarea"
                        }
                      />
                      {touched.issue && errors.issue && (
                        <p className="errorMessageTextarea">{errors.issue}</p>
                      )}
                    </div>
                  </CSSTransition>
                  <CSSTransition
                    in={!(values.date === "" || values.time === "")}
                    classNames="fade"
                    nodeRef={cssTansition2}
                    timeout={duration}
                  >
                    <div className="fade-container" ref={cssTansition2}>
                      <h2 className="form-headline">Ihre Daten (3 / 3)</h2>
                      <DropdownSelect
                        name="salutation"
                        items={salutation}
                        label="Ihre Anrede"
                      />
                      <MyInputField
                        label="Vorname"
                        name="firstname"
                        type="text"
                        placeholder="Ihr Vorname"
                        required
                      />

                      <MyInputField
                        label="Nachname"
                        name="lastname"
                        type="text"
                        placeholder="Ihr Nachname"
                        required
                      />

                      <MyInputField
                        label="Straße"
                        name="street"
                        type="text"
                        placeholder="Ihre Straße und Hausnummer"
                      />

                      <MyInputField
                        label="Ort"
                        name="place"
                        type="text"
                        placeholder="Ihre Stadt"
                      />

                      <MyInputField
                        label="PLZ"
                        name="plz"
                        type="text"
                        placeholder="Ihre Postleitzahl"
                      />

                      <MyInputField
                        label="Email"
                        name="email"
                        type="email"
                        placeholder="Ihre Email-Adresse"
                        required
                      />

                      <MyInputField
                        label="Telefon"
                        name="number"
                        type="text"
                        placeholder="Ihre Telefonnummer"
                        required
                      />

                      <div className="container__checkbox">
                        <div className="container__checkbox_inner">
                          <label className="label">
                            <Field
                              type="checkbox"
                              className="checkbox"
                              name="checked"
                            />
                            Ich bin damit einverstanden, dass die E-Mail-Adresse
                            zu Zwecken der Terminverarbeitung und der Zusendung
                            einer Bestätigung verwendet wird. Sollte ich keine
                            E-Mail-Adresse angeben, wird mir eine Druckansicht
                            der Bestätigung angezeigt.
                          </label>
                        </div>
                        {touched.checked && errors.checked && (
                          <p className="errorMessageCheckbox">
                            {errors.checked}
                          </p>
                        )}
                      </div>
                      <div className="button-container">
                        <Buttons
                          className="large small"
                          type="submit"
                          content="Termin buchen"
                          disabled={isLoading}
                        ></Buttons>
                      </div>
                    </div>
                  </CSSTransition>
                </Form>
              );}}
            </Formik>
          </div>
        </div>
      ) : null}
      {isSuccess && userData ? (
        <>
          <div className="main">
            <div className="container_daten_alle">
              <h1>Vielen Dank für Ihre Terminbuchung!</h1>
              <div className="container_daten">
                <p>
                  Sehr{" "}
                  {userData.customer.salutation?.string === "Herr"
                    ? "geehrter"
                    : userData.customer.salutation?.string === "Frau"
                    ? "geehrte"
                    : "geehrte:r"}{" "}
                  {userData.customer.salutation?.string}{" "}
                  {userData.customer.first_name} {userData.customer.last_name},
                </p>

                <p>gerne bestätigen wir Ihnen Ihren Termin.</p>

                <p>
                  Wir freuen uns darauf, Sie am{" "}
                  <strong>
                    {dayjs(userData.start).format("DD.MM.YYYY")} um{" "}
                    {dayjs(userData.start).format("HH:mm")} Uhr
                  </strong>{" "}
                  in unserer Hauptverwaltung begrüßen zu dürfen.
                </p>

                <p>
                  <strong>Anschrift:</strong>
                  <br />
                  Stadtwerke Witten GmbH
                  <br />
                  {userData.location.street}
                  <br />
                  {userData.location.zip_code} {userData.location.place}
                </p>

                <p>
                  <strong>Hinweise zu Ihrem Besuch</strong>
                </p>

                <ul>
                  <li>
                    Wenn Sie mit dem Auto anreisen, können Sie auf unser
                    Werksgelände fahren. Besucherparkplätze stehen dort in
                    ausgeschilderten Bereichen zur Verfügung.
                  </li>
                  <li>
                    Vom Parkplatz gehen Sie zum Eingang der Hauptverwaltung und
                    klingeln dort bei „Anmeldung“. Sie werden anschließend
                    hineingelassen.
                  </li>
                  <li>
                    Nach Ihrer Anmeldung nehmen Sie in unserem Wartebereich
                    Platz. Von dort werden Sie von Ihrer Ansprechperson abgeholt.
                  </li>
                </ul>

                <p>
                  Falls Sie den Termin nicht wahrnehmen können, bitten wir um
                  eine kurze Absage unter
                  <br />
                  <strong>{userData.support_phone_number}</strong>.
                </p>

                <p>Mit freundlichen Grüßen</p>

                <p>{userData.email_sender_salutation}</p>
              </div>
            </div>
          </div>
        </>
      ) : null}
      <footer className="footer">
        <ul className="footer__list">
          <li className="footer__list-item">
            <a
              className="footer__link"
              href="https://www.stadtwerke-witten.de/impressum"
              target="_blank"
              rel="noreferrer"
            >
              Impressum
            </a>
          </li>
          <li className="footer__list-item">
            <a
              className="footer__link"
              href="https://www.stadtwerke-witten.de/datenschutz"
              target="_blank"
              rel="noreferrer"
            >
              Datenschutz
            </a>
          </li>
        </ul>
      </footer>
    </div>
  );
};

export default Formular;
